export enum ConfigOfferKey {
  BUSINESS_CARD = "BUSINESS_CARD",
  PAYOUT = "PAYOUT",
  LIMIT_TRANSACTION = "LIMIT_TRANSACTION",
  LIMIT_DIRECT_DEBIT = "LIMIT_DIRECT_DEBIT",
  SMART_ACCESS = "SMART_ACCESS",
}

export enum ConfigUnderOfferKey {
  PHYSICAL_CARD = "PHYSICAL_CARD",
  VIRTUAL_CARD = "VIRTUAL_CARD",
  PAIEMENT_CARD = "PAIEMENT_CARD",
  PAYOUT = "PAYOUT",
  PAYOUT_INST = "PAYOUT_INST",
  LIMIT_TRANSACTION = "LIMIT_TRANSACTION",
  LIMIT_TRANSACTION_DAILY = "LIMIT_TRANSACTION_DAILY",
  LIMIT_TRANSACTION_MONTHLY = "LIMIT_TRANSACTION_MONTHLY",
  LIMIT_DIRECT_DEBIT = "LIMIT_DIRECT_DEBIT",
  LIMIT_DIRECT_DEBIT_MONTHLY = "LIMIT_DIRECT_DEBIT_MONTHLY",
  USERS = "USERS",
}
